import { FC, memo } from 'react'

import { BankAccount } from 'commons/types/DTO/bank/quarterlyReport/bankAccount'
import { IconSize } from 'ui/components/Icon'
import { PageSectionPrimary, PageSectionSecondary } from 'ui/components/Page'
import { TextMask } from 'ui/components/TextMask'

import { BankAccountDataProps } from './BankAccountDataProps'
import {
  DepositsFromSalesTable,
  OtherBankActivityTable,
  SalesReportTable,
  SalesToDepositComparisonTable
} from './components'

import * as SC from './styles'

export const BankAccountData: FC<BankAccountDataProps> = memo(({ item }) => {
  const { bankAccounts } = item

  return (
    <>
      {bankAccounts.map((account: BankAccount, index) => {
        const showSalesReportTable = account.showSalesRetail !== undefined || account.showSalesWholesale !== undefined

        return (
          <PageSectionPrimary
            key={index}
            face="solid"
            expanded
            foldable
            title={
              <div style={{ display: 'flex', gap: '10px' }}>
                <h3>Bank Account #{index + 1}</h3>
                <TextMask
                  isBankAccount
                  text={account.bankAccountNumber || '---'}
                  link={account.bankAccountId ? `/bank-accounts/${account.bankAccountId}` : undefined}
                  iconSize={IconSize.XS}
                />
              </div>
            }
            anchor={`bank-account-${index}`}
          >
            {account.warnings && account.warnings.length > 0 && <SC.WrappedWarnings warnings={account.warnings} />}
            {showSalesReportTable && (
              <PageSectionSecondary face="outlined" title="Cannabis Sales Report">
                <SalesReportTable bankAccount={account} />

                {account.depositsFromSales && <DepositsFromSalesTable {...account.depositsFromSales} />}
                {account.showOtherActivity && <OtherBankActivityTable {...account.showOtherActivity} />}
                <br />
                {account.salesToDepositsComparison && (
                  <SalesToDepositComparisonTable item={account.salesToDepositsComparison} />
                )}
              </PageSectionSecondary>
            )}
          </PageSectionPrimary>
        )
      })}
    </>
  )
})
